/* eslint-disable indent */
import { Component } from '@angular/core';
import { WrapFormItemEnum } from '../../interfaces/form-item.model';
import { BaseComponent } from '../base/base.component';




@Component({
  selector: 'cargoes-form-item',
  templateUrl: './form-item.component.html',
  styleUrls: ['./form-item.component.less'],
})
export class FormItemComponent extends BaseComponent {
  wrapFormItemEnum = WrapFormItemEnum;

  inputType() {
    return Object.keys(this.parameters.data.formControl)[0];
  }
}
